import axios from 'axios'
import router from '../router/index'
import {message} from "ant-design-vue";

// 创建axios实例
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
axios.defaults.timeout = 60000;

// request拦截器
axios.interceptors.request.use(
  config => {

    return config
  },
  error => {
    return Promise.reject(error);
  }
);

let messageInstance = null;
let timer = null;
// response拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if(response.data === null) {
        return
      }
      if (response.data.data === undefined) {
        return response.data
      }
      return response.data.data
    }
    message.error(response.data.message);
    return Promise.reject(response.data.message)
  },
  error => {
    console.log(error.response);
    // 401:未登录,或者登录失败
    if (error.response.status === 401) {
      // 清除登录信息
      if (messageInstance) {
        if (timer) {
          clearTimeout(timer)
        } else {
          setTimeout(() => {
            messageInstance = null
          }, 2000);
        }
      } else {
        messageInstance = message.error('登录过期，请重新登录')
      }

      return Promise.reject('登录过期，请重新登录')
    }
    if (error.response.status === 500) {
      var errMsg = error.response.data.message;
      const result = errMsg.match(/[\u4e00-\u9fa5]/g) || [];
      if (result.length > 3) {
        // 如果有三个以上的汉字，则抛出
        message.error(errMsg);
      }
      // return Promise.reject('服务器异常')
    }
    return Promise.reject(error.response.data.message)
  }
);
